<script>
export default {
  name: 'NonDynamicTransportSuppliers',
  props: {
    suppliers: {
      type: Array,
      required: true,
    },
    ticketHandling: {
      type: String,
      default: null,
    },
    supplierId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      currentSupplier: null,
      currency: null,
    };
  },
  methods: {
    selectSupplier(supplier) {
      if (typeof (supplier) !== 'undefined') {
        this.currentSupplier = supplier;
        this.currency = supplier.currency || '';
        this.$emit('set-supplier', supplier.id);
      } else {
        this.$emit('set-supplier', null);
        this.currentSupplier = null;
        this.currency = null;
      }
    },
    setTicketHandling(ticketHandling) {
      this.$emit('set-ticket-handling', ticketHandling);
    },
    setCurrency() {
      if (this.supplierId) {
        const supplier = this.suppliers.find(e => e.id === this.supplierId);
        if (supplier) {
          this.currency = supplier.currency;
        }
      }
    },
  },
  created() {
    this.setCurrency();
  },
};
</script>

<template>
  <v-layout row>
    <v-flex sm3 d-flex>
      <v-autocomplete
        :label="$t('nonDynamicTransport.labels.chooseSupplier')"
        :items="suppliers"
        :value="supplierId"
        item-text="name"
        item-value="id"
        class="mr-2"
        clearable
        solo
        return-object
        @change="selectSupplier"
      />
    </v-flex>
    <v-flex
      v-show="currency"
      shrink
      sm1
    >
      <v-expand-x-transition>
        <v-text-field
          v-show="currency"
          :label="$t('nonDynamicTransport.labels.currency')"
          :value="currency"
          class="mr-2"
          solo
          disabled
        />
      </v-expand-x-transition>
    </v-flex>
    <v-flex sm3>
      <v-text-field
        :value="ticketHandling"
        :label="$t('nonDynamicTransport.labels.ticketHandling')"
        solo
        @input="setTicketHandling"
      />
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportSuppliers.vue